<template>
  <div class="registration_list">
    <template v-if="!swimmingView && !wsView && !aerobicView">
      <div class="query_wapper">
        <div class="query_item">
          <el-select :popper-append-to-body="false" v-model="query.year" @change="selectYear">
            <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
        </div>
        <div class="query_item">
          <el-select
            :popper-append-to-body="false"
            clearable
            v-model="query.groupId"
            @change="handleSearch"
          >
            <el-option :value="''" label="全部组别"></el-option>
            <el-option
              v-for="(item,index) in registGroup"
              :key="index"
              :value="item.value"
              :label="item.label"
            ></el-option>
            <el-option v-if="userInfo.project == 7" value="5" label="混合组"></el-option>
          </el-select>
        </div>
        <div class="query_item">
          <el-select
            :popper-append-to-body="false"
            v-model="query.matchId"
            placeholder="请选择赛事"
            clearable
            @change="handleSearch"
          >
            <el-option
              v-for="(item,index) in matchList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </div>
        <div class="query_item">
          <el-input
            v-model="query.keyword"
            clearable
            placeholder="关键词搜索"
            style="width:290px"
            @keyup.enter.native="handleSearch"
          >
            <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
          </el-input>
        </div>
        <div class="query_item">
          <el-button type="warning" v-if="false" style="width:90px">打印</el-button>
          <el-button style="width:90px;border-radius:4px" class="search_btn" @click="exportExcel">导出</el-button>
        </div>
        <div class="query_item" v-if="userInfo.project !== 4">
          <el-button type="primary" @click="exportAllWord">导出Word</el-button>
        </div>
        <div class="query_item">
          <el-button
            class="search_btn"
            style="width:auto;border-radius:4px"
            @click="exportAllExcel"
          >导出Excel</el-button>
        </div>
      </div>
      <p class="all_data">
        共
        <span>{{total}}</span>条数据
      </p>
      <el-table border :data="tableData" style="width:100%" v-if="!isOtherBall">
        <el-table-column type="index" width="80" align="center" label="序号"></el-table-column>
        <el-table-column min-width="150" label="赛事名称" prop="matchName" align="center"></el-table-column>
        <el-table-column prop="schoolName" align="center" label="已报名学校" min-width="120"></el-table-column>
        <el-table-column prop="count" align="center" label="运动员人数" width="100"></el-table-column>
        <el-table-column
          v-if="userInfo.project ==2 || userInfo.project ==3"
          :prop="userInfo.project === 2?'leadNameCountText':'leaderName'"
          align="center"
          label="领队"
          min-width="100"
        ></el-table-column>
        <el-table-column
          v-if="userInfo.project ==2 || userInfo.project ==3"
          :prop="userInfo.project === 2?'coachIdsCountText':'coachNames'"
          align="center"
          label="教练"
          min-width="100"
        ></el-table-column>

        <el-table-column
          v-if="userInfo.project !== 9 && userInfo.project !==2 && userInfo.project !== 4 && userInfo.project !==3"
          prop="groupText"
          align="center"
          label="组别"
        ></el-table-column>
        <el-table-column
          v-if="userInfo.project !== 4 && userInfo.project !==2 && userInfo.project !==3"
          align="center"
          label="主教练"
        >
          <template slot-scope="{row}">
            <span>{{row.concatName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="userInfo.project !== 4 && userInfo.project !==2 && userInfo.project !==3"
          prop="workerNames"
          align="center"
          label="工作人员"
        ></el-table-column>
        <el-table-column
          v-if="userInfo.project !== 4 && userInfo.project !== 3"
          prop="concatPhone"
          align="center"
          label="联系电话"
          min-width="120"
        ></el-table-column>
        <el-table-column
          v-if="userInfo.project === 3"
          prop="leaderPhone"
          align="center"
          label="联系电话"
          min-width="120"
        ></el-table-column>
        <el-table-column prop="createDateText" align="center" min-width="120" label="报名表提交时间"></el-table-column>
        <el-table-column align="center" label="报名表查看" width="300">
          <template slot-scope="{row}">
            <el-button type="text" @click="watchRegistration(row)">查看</el-button>
            <el-button
              type="text"
              v-if="userInfo.project !== 4 && userInfo.project !== 2 && userInfo.project !==3"
              @click="makePrint(row.id)"
            >打印</el-button>
            <el-button
              type="text"
              v-if="!isOtherBall && userInfo.project !== 9 && userInfo.project !== 4 && userInfo.project !== 2 && userInfo.project !==3"
              @click="makePdf(row.id)"
            >导出PDF</el-button>
            <el-button v-if="userInfo.project !== 4" type="text" @click="exportWord(row.id)">导出Word</el-button>
            <el-button type="text" @click="exportExcels(row.id)">导出Excel</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-table border :data="tableData" v-else style="width:100%">
        <el-table-column type="index" width="60" align="center" label="序号"></el-table-column>
        <el-table-column label="学校名称" prop="schoolName" width="180px" align="center"></el-table-column>
        <el-table-column label="参赛项目" align="center">
          <el-table-column label="男团" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallGroup1}}</template>
          </el-table-column>
          <el-table-column label="女团" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallGroup0}}</template>
          </el-table-column>
          <el-table-column label="男单" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallSingles1}}</template>
          </el-table-column>
          <el-table-column label="女单" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallSingles0}}</template>
          </el-table-column>
          <el-table-column label="男双" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallDoubles1}}</template>
          </el-table-column>
          <el-table-column label="女双" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallDoubles0}}</template>
          </el-table-column>
          <el-table-column label="混双" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.smallBallMixed}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="教练员" width="70" align="center">
          <template slot-scope="{row}">{{row.smallBallCount.coach}}</template>
        </el-table-column>
        <el-table-column label="领队/其他" width="100" align="center">
          <template slot-scope="{row}">{{row.smallBallCount.leader}}</template>
        </el-table-column>
        <el-table-column label="运动员人数" align="center">
          <el-table-column label="男" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.man}}</template>
          </el-table-column>
          <el-table-column label="女" width="55" align="center">
            <template slot-scope="{row}">{{row.smallBallCount.woman}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="合计" width="55" align="center" prop="count"></el-table-column>
        <el-table-column label="住宿" align="center">
          <el-table-column label="男" width="55" align="center" prop="stayMan"></el-table-column>
          <el-table-column label="女" width="55" align="center" prop="stayWoman"></el-table-column>
        </el-table-column>
        <el-table-column label="主教练" width="90" align="center" prop="concatName"></el-table-column>
        <el-table-column label="联系方式" width="120" align="center" prop="concatPhone"></el-table-column>
        <!-- <el-table-column label="备注" width="100" align="center"></el-table-column> -->
        <el-table-column align="center" label="报名表查看" min-width="170">
          <template slot-scope="{row}">
            <el-button type="text" @click="watchRegistration(row)">查看</el-button>
            <el-button type="text" @click="makePrint(row.id)">打印</el-button>
            <el-button
              type="text"
              v-if="!isOtherBall && userInfo.project !== 9"
              @click="makePdf(row.id)"
            >导出PDF</el-button>
            <el-button type="text" @click="exportWord(row.id)">导出Word</el-button>
            <el-button type="text" @click="exportExcels(row.id)">导出Excel</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align:center;margin:20px 0 0 0"
        :page-sizes="pageSizeList"
        :page-size="pageSize"
        @size-change="$event=>sizeChange($event,this.getList)"
        @current-change="$event=>numberChange($event,this.getList)"
        :current-page.sync="pageNo"
        background
        layout="prev, pager, next,sizes"
        :total="total"
      ></el-pagination>
      <div id="listPrint" style="position:absolute;left:-50000px;top:-50000px">
        <listPrint ref="listPrint" :info="printInfo" :matchList="matchList"></listPrint>
      </div>
      <el-dialog
        :lock-scroll="false"
        :append-to-body="true"
        center
        :close-on-click-modal="false"
        :title="title"
        @close="closeModal"
        :visible.sync="centerDialogVisible"
        width="1120px"
        top="60px"
      >
        <registrationFormView
          :isListPrint="isListPrint"
          ref="registrationFormViewChild"
          :info="info"
          :matchList="matchList"
        ></registrationFormView>
        <span slot="footer" class="dialog-footer">
          <el-button style="width:90px;" @click="centerDialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else-if="swimmingView">
      <registrationView
        :isListPrint="isListPrint"
        @backs="moveBack"
        :info="info"
        :matchList="matchList"
      ></registrationView>
    </template>
    <template v-else-if="wsView">
      <martialView :isListPrint="isListPrint" @backs="moveBack" :info="info" :matchList="matchList"></martialView>
    </template>
    <template v-else>
      <aerobicsView
        :isListPrint="isListPrint"
        @backs="moveBack"
        :info="info"
        :matchList="matchList"
      ></aerobicsView>
    </template>
  </div>
</template>
<script>
import listPrint from "./components/list-print";
import registrationFormView from "./components/registration-form-view";
import registrationView from "./components/registration-view";
import { getMatchList } from "@/api/sports-management";
import { getSession } from "@/utils/storage.js";
import { signList } from "@/api/sign-up-match";
import registerData from "@/assets/json/register.json";
import martialView from "./components/martial-view.vue";
import aerobicsView from "./components/aerobics-view.vue";
import {
  table,
  message,
  page,
  dialog,
  selectiveYear
} from "@/common/js/mixins";
import { baseUrl } from "@/utils/config";
export default {
  mixins: [table, message, page, dialog, selectiveYear],
  components: {
    registrationFormView,
    registrationView,
    listPrint,
    martialView,
    aerobicsView,
    
  },
  data() {
    return {
      matchList: [],
      isListPrint: false,
      info: {
        id: "",
        year: "",
        matchId: ""
      },
      printInfo: {
        id: "",
        year: "",
        matchId: ""
      },
      userInfo: JSON.parse(getSession("userInfo")) || "",
      swimmingView: false,
      wsView: false,
      aerobicView: false,
      query: {
        groupId: "",
        year: new Date().getFullYear(),
        keyword: "",
        matchId: ""
      }
    };
  },
  computed: {
    // 网球、羽毛球、乒乓球、田径公用
    isOtherBall() {
      return (
        this.userInfo.project === 1 ||
        this.userInfo.project === 5 ||
        this.userInfo.project === 6
      );
    },
    // 获取注册组别
    registGroup() {
      return registerData.registGroup;
    }
  },
  methods: {
    // 游泳详情返回
    moveBack() {
      this.swimmingView = false;
      this.wsView = false;
      this.aerobicView = false;
    },
    // 调用打印
    makePrint(id) {
      this.isListPrint = true;
      if (this.userInfo.project === 4) {
        Object.assign(this.printInfo, {
          id,
          matchId: this.query.matchId,
          year: this.query.year
        });
        let interval = setInterval(() => {
          if (this.$refs.swimmingPrints.isRender) {
            clearInterval(interval);
            this.$refs.swimmingPrints.print();
            this.isListPrint = false;
          }
        }, 300);
      } else {
        this.$nextTick(() => {
          Object.assign(this.printInfo, {
            id,
            matchId: this.query.matchId,
            year: this.query.year
          });
        });
        let interval = setInterval(() => {
          if (this.$refs.listPrint.isRender) {
            clearInterval(interval);
            this.$refs.listPrint.print();
            this.isListPrint = false;
          }
        }, 300);
      }
    },
    // 导出word（单个）
    exportWord(id) {
      window.location.href = baseUrl + "/match/sign/getWord?id=" + id;
    },
    // 导出word（多个）
    exportAllWord() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          if (k === "groupId" && this.query[k] == "5") {
            params.push(k + "=");
          } else params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      window.location.href =
        baseUrl + "/match/sign/getWordList?" + params.join("&");
    },
    // 导出Excel（多个）
    exportAllExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          if (k === "groupId" && this.query[k] == "5") {
            params.push(k + "=");
          } else params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      window.location.href =
        baseUrl + "/match/sign/getExcelList?" + params.join("&");
    },
    // 导出Excel（单个）
    exportExcels(id) {
      window.location.href = baseUrl + "/match/sign/getExcel?id=" + id;
    },
    // 导出pdf
    makePdf(id) {
      this.isListPrint = true;
      this.$nextTick(() => {
        Object.assign(this.printInfo, {
          id,
          matchId: this.query.matchId,
          year: this.query.year
        });
      });
      let interval = setInterval(() => {
        if (this.$refs.listPrint.isRender) {
          clearInterval(interval);
          this.isOtherBall
            ? this.$refs.listPrint.exportPdfRow()
            : this.$refs.listPrint.exportPdf();
          this.isListPrint = false;
        }
      }, 300);
    },
    // 选择年份
    selectYear() {
      this.tableData = [];
      this.query.matchId = "";
      this.total = 0;
      this.pageNo = 1;
      this.getMatch();
    },
    // 获取赛事列表
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
        })
        .catch(err => {});
    },
    // 查看
    watchRegistration(data) {
      Object.assign(this.info, {
        id: "",
        matchId: "",
        year: ""
      });
      let matchId = "";
      if (!this.query.matchId) {
        this.matchList.filter(item => {
          if (item.name === data.matchName) matchId = item.id;
        });
      } else matchId = this.query.matchId;
      if (this.userInfo.project === 4) {
        Object.assign(this.info, {
          id: data.id,
          matchId,
          year: this.query.year
        });
        this.swimmingView = true;
      } else if (this.userInfo.project === 2) {
        Object.assign(this.info, {
          id: data.id,
          matchId,
          year: this.query.year
        });
        this.wsView = true;
      } else if (this.userInfo.project === 3) {
        Object.assign(this.info, {
          id: data.id,
          matchId,
          year: this.query.year
        });
        this.aerobicView = true;
      } else {
        this.openDialog("查看报名表");
        this.$nextTick(() => {
          Object.assign(this.info, {
            id: data.id,
            matchId,
            year: this.query.year
          });
        });
      }
    },
    // 导出表格
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      window.location.href =
        baseUrl + "/match/sign/downloadList?" + params.join("&");
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 列表数据
    getList(data) {
      signList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        groupId: this.query.groupId === "5" ? "" : this.query.groupId
      })
        .then(res => {
          this.total = res.total;
          this.tableData = res.list;
        })
        .catch(err => {});
    },
    // 关闭弹窗
    closeModal() {
      if (this.$refs.registrationFormViewChild.loading) {
        this.$refs.registrationFormViewChild.loading.close();
      }
      Object.assign(this.info, this.$options.data().info);
    }
  },
  mounted() {
    this.getList();
    this.getYearLists(this.query, this.getMatch);
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/font/pf.css";
.all_data {
  margin: 10px 0 20px;
  color: #444;
  font-size: 18px;
  font-family: PF;
  > span {
    color: #1e63b0;
    font-weight: 600;
    font-size: 20px;
  }
}
.registration_list {
  .query_wapper {
    .query_item {
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }
  /deep/ .el-button--text {
    padding: 0;
  }
  /deep/ .el-table td {
    padding: 4px 0;
  }
  /deep/ .el-table .cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  /deep/ .el-table thead {
    color: #444;
    font-size: 14px;
    th {
      background: #eee;
      border-right: 1px solid #ddd;
    }
  }
  /deep/ .el-table td,
  /deep/ .el-table th.is-leaf {
    padding: 4px 0;
  }
}
</style>